import "./App.css";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./views/user/login";
import Error from "views/error";
import Unauthorized from "views/unauthorized";
import AppLayout from "layout/AppLayout";
import Blank from "views/app/Blank";
import { PrivateRoute } from "auth/privateRoute";
import PricesList from "views/app/details/pricesList";
import AddPrice from "views/app/details/priceAdd";
import PaymentsList from "views/app/payments/paymentsList";
import PaymentView from "views/app/payments/paymentView";
import PinsList from "views/app/pins/pinsList";
import CheckPin from "views/app/pins/checkPin";
import SmartupBulkImport from "views/app/smartupBulkImport";
import SmartupSync from "views/app/smartup/smartupSync";
import PromocodeRequests from "views/app/promocodes/promocodeRequests";
import PromocodesList from "views/app/promocodes/promocodesList";
import PromocodeForm from "views/app/promocodes/promocodeForm";
import PromocodeView from "views/app/promocodes/promocodeView";
import { AdminRoute } from "auth/adminRoute";
import { PermissionRoute } from "auth/permissionRoute";
import UsersList from "views/app/users/usersList";
import AddUser from "views/app/users/add";
import PosTerminal from "views/app/pos/posTerminal";
import PosSalesList from "views/app/pos/posSalesList";

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />

          <Route path="/error" element={<Error />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="/app"
            element={
              <PrivateRoute>
                <PaymentsList />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/payments"
            element={
              <PrivateRoute>
                <PaymentsList />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/payments/enquiry/:id"
            element={
              <PrivateRoute>
                <PaymentView />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/prices"
            element={
              <PrivateRoute>
                <PricesList />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/prices/:id"
            element={
              <PrivateRoute>
                <AddPrice />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/pins"
            element={
              <PrivateRoute>
                <PinsList />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/checkpin"
            element={
              <PrivateRoute>
                <CheckPin />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/smartup-bulk-import"
            element={
              <PrivateRoute>
                <SmartupBulkImport />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/smartup-sync"
            element={
              <AdminRoute>
                <SmartupSync />
              </AdminRoute>
            }
          />

          <Route
            path="/app/promocode-requests"
            element={
              <AdminRoute>
                <PromocodeRequests />
              </AdminRoute>
            }
          />

          <Route
            path="/app/promocodes"
            element={
              <AdminRoute>
                <PromocodesList />
              </AdminRoute>
            }
          />
          <Route
            path="/app/promocodes/add"
            element={
              <AdminRoute>
                <PromocodeForm />
              </AdminRoute>
            }
          />
          <Route
            path="/app/promocodes/:id"
            element={
              <AdminRoute>
                <PromocodeView />
              </AdminRoute>
            }
          />
          <Route
            path="/app/promocodes/:id/edit"
            element={
              <AdminRoute>
                <PromocodeForm />
              </AdminRoute>
            }
          />

          <Route
            path="/app/pos"
            element={
              <PermissionRoute permission="posAccess">
                <PosTerminal />
              </PermissionRoute>
            }
          />
          <Route
            path="/app/pos/sales"
            element={
              <PermissionRoute permission="posAccess">
                <PosSalesList />
              </PermissionRoute>
            }
          />
          <Route
            path="/app/pos/catalogue"
            element={<Navigate to="/app/prices" replace />}
          />

          <Route
            path="/app/users"
            element={
              <AdminRoute>
                <UsersList />
              </AdminRoute>
            }
          />
          <Route
            path="/app/users/add"
            element={
              <AdminRoute>
                <AddUser />
              </AdminRoute>
            }
          />
          <Route
            path="/app/users/:id"
            element={
              <AdminRoute>
                <AddUser />
              </AdminRoute>
            }
          />

          <Route
            path="/app/blank"
            element={
              <PrivateRoute>
                <Blank />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
